import { Component, OnInit } from '@angular/core';
import { EtapasEstadosDto } from '../../../dto/etapas-estados/etapas-estados-dto';
import { TableColumn } from '../../../dto/util/table-column';
import { TableAction } from '../../../dto/util/table-action';
import { combineLatest, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormField } from '../../../dto/util/form-field';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { TableroResumenService } from '../services/tablero-resumen.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ListasService } from '../../../services/listas.service';
import { EstadosExpedienteDto } from '../../../dto/expediente/estados-expediente-entidad.dto';

@Component({
  selector: 'app-tablero-resumen-ciudadano',
  templateUrl: './tablero-resumen-ciudadano.component.html',
  styleUrl: './tablero-resumen-ciudadano.component.scss'
})
export class TableroResumenCiudadanoComponent implements OnInit {

  etapaActiva = 0;
  progreso = 0;

  // Tablas
  datosEtapas: EtapasEstadosDto[] = [];
  columnasEtapas: TableColumn[] = [];
  actions: TableAction[] = [];

  totalPaginasEtapas = 0;
  paginaActualEtapas = 1;

  // Multilenguaje
  tableroText: any = {};

  onlyView: boolean = true;
  addEtapas: boolean = false;
  // Formularios
  etapaFormFields: FormField[] = [];
  // Indice arreglo estado
  indice: number | undefined = undefined;
  idEtapaEditar: number | undefined = undefined;
  idEntidad!: number;
  estadosEntidad: EstadosExpedienteDto[] = [];
  constructor(
    private readonly translate: TranslateService,
    private readonly tableroResumenService: TableroResumenService,
    private readonly alertService: AlertaModalService,
    private readonly listaEstadoService: ListasService
  ) { }

  ngOnInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    // Se obtiene el ID de la entidad desde la sesión
    this.idEntidad = infoInicioSesion.Id_Entidad;

    combineLatest([
      this.translate.stream('gestion-tablero-resumen'),
    ]).subscribe(([tramitesText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.tableroText[key] = tramitesText[key];
      }
      this.iniciarColumnas();
      this.initForm();
    });
    this.getEstadosAsociadosByIdEntidad();
    this.getEtapas();

  }

  // tablas
  private iniciarColumnas() {
    this.columnasEtapas = [
      {
        field: 'Etapa',
        title: this.tableroText['nombre-etapa'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'Descripcion',
        title: this.tableroText['detalle-etapa'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'Estado',
        title: this.tableroText['estados-asociados'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: 'editar',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: 'eliminar',
      },
    ];
  }

  // Listas
  getEtapas() {
    this.tableroResumenService.listarEtapasProceso(this.idEntidad).subscribe({
      next: (data) => {
        data = data.map((item: any) => {
          return {
            ...item,
            Estado: item.Estado_Expediente.map((e: any) => e.Estado)
          };
        });
        this.datosEtapas = data;

      },
      error: (error) => {
      }
    });
  }

  getEstadosAsociadosByIdEntidad() {
    this.listaEstadoService.getEstadoExpedienteByIdEntidad(this.idEntidad).subscribe({
      next: (value) => {
        this.estadosEntidad = value;
        const estados = value.map((elemento) => ({
          Id: elemento.Id,
          Nombre: elemento.Estado
        }));
        const estadosField = this.etapaFormFields.find(field => field.name === 'estadosAsociados');
        if (estadosField) {
          estadosField.options = estados;
          this.etapaFormFields = [...this.etapaFormFields];
        }
      },
      error: (error) => {

      }
    })
  }

  clickHorizontalAdvanceLine(index: number): void {
    this.etapaActiva = index;
    this.progreso = (index + 1) * (100 / this.datosEtapas.length);
  }

  initForm() {
    this.etapaFormFields = [
      {
        name: 'nombreEstado',
        label: this.tableroText['nombre-etapa'],
        placeholder: this.tableroText['nombre-etapa'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(20),
          Validators.pattern(Constants.REGEX_SOLO_UNA_PALABRA),
        ],
        errorMessages: {
          required: this.tableroText['nombre-etapa-required'],
          minlength: this.tableroText['nombre-etapa-minlength'],
          maxlength: this.tableroText['nombre-etapa-maxlength'],
          pattern: this.tableroText['nombre-etapa-pattern'],
        },
      },
      {
        name: 'orden',
        label: this.tableroText['orden'],
        placeholder: this.tableroText['orden'],
        type: 'number',
        required: true,
        width: '6',
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.tableroText['orden-required'],
          pattern: this.tableroText['orden-pattern'],
        },
      },
      {
        name: 'detalleEstado',
        label: this.tableroText['detalle-etapa'],
        placeholder: this.tableroText['detalle-etapa'],
        type: 'textarea',
        required: false,
        width: '12',
        noConvertToUpperCase: true,
        validation: [
          Validators.minLength(3),
          this.maxWordsValidator(25),
          Validators.pattern(Constants.REGEX_NOMBRE_EVENTO),
        ],
        errorMessages: {
          required: this.tableroText['detalle-etapa-required'],
          minlength: this.tableroText['detalle-etapa-minlength'],
          maxlength: this.tableroText['detalle-etapa-maxlength'],
          pattern: this.tableroText['detalle-etapa-pattern'],
        },
      },
      {
        name: 'estadosAsociados',
        label: this.tableroText['estados-asociados'],
        type: 'select',
        multiple: true,
        required: true,
        options: this.etapaFormFields?.find(f => f.name === 'estadosAsociados')?.options || [],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.tableroText['estados-asociados-required'],
        },
      },
      {
        name: 'estado',
        label: this.tableroText['estados'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        options: [
          { Id: 1, Nombre: 'Activo' },
          { Id: 0, Nombre: 'Inactivo' },
        ],
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.tableroText['estados-required'],
        },
      },
    ];
  }

  maxWordsValidator(maxWords: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // Si está vacío no hay error

      const wordCount = control.value.trim().split(/\s+/).length;
      return wordCount > maxWords
        ? { maxWords: { requiredWords: maxWords, actualWords: wordCount } }
        : null;
    };
  }

  acciones(event: any) {
    const etapaEstado = event.item as EtapasEstadosDto;
    if (event.idAccion == 'editar') {
      this.onlyView = false;
      this.setearFormEstado(etapaEstado, event.index);
    } else if (event.idAccion == 'eliminar') {
      this.eliminarEtapa(etapaEstado);
    } else {
      this.addEtapas = true;
      this.onlyView = false;
    }
  }

  getFlag() {
    if (!this.onlyView && !this.addEtapas) return 'editar';
    if (!this.onlyView && this.addEtapas) return 'agregar';
    return 'ver';
  }

  goBack() {
    this.getEtapas();
    this.onlyView = true;
    this.addEtapas = false;
    this.setearForm();
  }


  onSubmitForm(event: FormGroup) {
  }

  setearFormEstado(etapaEstado: EtapasEstadosDto, index: number) {
    this.etapaFormFields = this.etapaFormFields.map(field => {
      switch (field.name) {
        case 'nombreEstado':
          field.value = etapaEstado.Etapa;
          break;
        case 'orden':
          field.value = etapaEstado.Orden;
          break;
        case 'detalleEstado':
          field.value = etapaEstado.Descripcion;
          break;
        case 'estadosAsociados':
          field.value = etapaEstado.Estado_Expediente
            ? etapaEstado.Estado_Expediente.map(e => e.Id).filter((id): id is string | number => id !== undefined)
            : [];
          break;
        case 'estado':
          field.value = etapaEstado.Estado ? 1 : 0;
          break;
      }
      return field;
    });
    this.idEtapaEditar = +etapaEstado.Id!;
    this.indice = index;
  }

  confirmarCambios(event: FormGroup, flag: string) {
    if (flag === 'editar') {
      this.guardarEdicion(event);
    } else if (flag === 'agregar') {
      this.guardarNuevo(event);
    }
  }

  // Guardar nueva etapa
  guardarNuevo(event: any) {
    if (this.datosEtapas.length > 8) {
      this.alertService.advertencia(this.tableroText['max-8-etapas']);
      return;
    }
    const etapa = {
      Etapa: event.value.nombreEstado,
      Descripcion: event.value.detalleEstado.toUpperCase(),
      Orden: +event.value.orden,
      Entidad_Id: this.idEntidad,
      Estado: event.value.estado === 1 ? true : false,
      EstadosExpedienteIds: event.value.estadosAsociados
    }
    this.datosEtapas.push(etapa);
    this.etapaFormFields = this.etapaFormFields.map(field => {
      field.value = undefined;
      return field;
    });
  }

  // Guardar edición etapa
  guardarEdicion(event: FormGroup) {
    this.addEtapas = false;
    const etapa = {
      Etapa: event.value.nombreEstado,
      Descripcion: event.value.detalleEstado.toUpperCase(),
      Orden: +event.value.orden,
      Entidad_Id: this.idEntidad,
      Estado: event.value.estado === 1 ? true : false,
      EstadosExpedienteIds: event.value.estadosAsociados
    };
    this.tableroResumenService.actualizarEtapaProceso(etapa, this.idEtapaEditar!).subscribe({
      next: (data) => {
        this.alertService.exito(this.tableroText['exito-mensaje']);
        this.getEtapas();
        this.onlyView = true;
        this.indice = undefined;
        this.setearForm();
      },
      error: (error) => {
        this.alertService.error(this.tableroText['error-mensaje']);
      }
    });
  }

  // Guardar procesos (nuevas etapas) servicio
  guardarProcesos() {
    if (this.datosEtapas.length < 5 || this.datosEtapas.length > 8) {
      this.alertService.advertencia(this.tableroText['etapas-minimo']);
      this.getEtapas();
      this.onlyView = true;
      this.addEtapas = false;
      return;
    }

    // Filtramos solo las etapas sin Id (nuevas)
    const etapasNuevas = this.datosEtapas.filter(e => !e.Id);

    if (etapasNuevas.length === 0) {
      this.alertService.advertencia(this.tableroText['etapas-vacias']);
      this.onlyView = true;
      this.addEtapas = false;
      return;
    }

    // Creamos un arreglo de observables solo con las nuevas
    const peticiones = etapasNuevas.map(etapa =>
      this.tableroResumenService.crearEtapaProceso(etapa)
    );

    forkJoin(peticiones).subscribe({
      next: (respuestas) => {
        this.alertService.exito(this.tableroText['exito-mensaje']);
        this.getEtapas(); // refrescar lista
        this.onlyView = true;
        this.addEtapas = false;
      },
      error: (err) => {
        this.alertService.error(this.tableroText['error-mensaje']);
      }
    });
  }

  // Eliminar etapa
  eliminarEtapa(event: any) {
    const etapaEstado = event as EtapasEstadosDto;
    this.alertService.confirmacion(
      this.tableroText['eliminar-etapa-mensaje'],
      this.tableroText['eliminar-etapa'],
      () => {
        this.tableroResumenService.eliminarEtapaProceso(+etapaEstado.Id!).subscribe({
          next: (data) => {
            this.alertService.exito(this.tableroText['exito-mensaje']);
            this.getEtapas();
            this.onlyView = true;
            this.addEtapas = false;
          }, error: (error) => {
            this.alertService.error(this.tableroText['error-mensaje']);
          }
        });
      }, () => {
        this.onlyView = true;
        this.addEtapas = false;
      }
    )
  }

  setearForm() {
    this.etapaFormFields = this.etapaFormFields.map(field => {
      return {
        ...field,
        value: undefined
      }
    });
  }

}
